import { memo } from "react";
import { MapPin } from "lucide-react";
import { photoUrl } from "../../lib/api";
import { priceLabel } from "../../lib/constants";
import { ListingCard } from "../ListingCard";
import { ListingsMap } from "../ListingsMap";
import { Button } from "../ui/button";
import { Skeleton } from "../ui/skeleton";

const Card = memo(ListingCard);

const MapRow = memo(function MapRow({ l }) {
  return (
    <a href={`/listing/${l.id}`} className="flex gap-3 bg-white rounded-xl border border-slate-200/80 p-3 hover:border-[#F5551E] transition-colors" data-testid={`map-list-item-${l.id}`}>
      <img src={photoUrl((l.photos || [])[0])} alt="" loading="lazy" className="h-16 w-16 rounded-lg object-cover shrink-0" />
      <div className="min-w-0">
        <p className="font-semibold text-[#12234A] truncate">{l.title}</p>
        <p className="text-[#F5551E] font-bold text-sm">{priceLabel(l)}</p>
        <p className="text-xs text-slate-500 flex items-center gap-1"><MapPin size={12} /> {l.city}, {l.province}</p>
      </div>
    </a>
  );
});

export function ResultsView({ t, listings, firstLoad, loading, view, province, onClear }) {
  if (firstLoad) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6" data-testid="results-skeleton">
        {[...Array(6)].map((_, i) => <Skeleton key={i} className="h-72 rounded-2xl" />)}
      </div>
    );
  }
  const fade = `transition-opacity duration-200 ${loading ? "opacity-50 pointer-events-none" : "opacity-100"}`;
  if (!listings.length) {
    return (
      <div className={`text-center py-24 bg-white rounded-2xl border border-slate-200/80 ${fade}`} data-testid="results-empty">
        <p className="text-slate-500">{t("br_none")}</p>
        <Button onClick={onClear} variant="outline" className="mt-4 rounded-xl" data-testid="empty-clear-filters">{t("br_clear_filters")}</Button>
      </div>
    );
  }
  if (view === "grid") {
    return (
      <div className={`grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6 ${fade}`} data-testid="results-grid">
        {listings.map((l) => <Card key={l.id} listing={l} />)}
      </div>
    );
  }
  return (
    <div className={`grid lg:grid-cols-2 gap-6 ${fade}`} data-testid="results-map">
      <ListingsMap listings={listings} province={province} />
      <div className="space-y-3 max-h-[600px] overflow-y-auto pr-1">
        {listings.map((l) => <MapRow key={l.id} l={l} />)}
      </div>
    </div>
  );
}
